import { useMemo } from 'react';
import { Column, ColumnProps, TableProps, Table } from '@tencent/spaui';
import _ from 'lodash';
import OverflowHoverTip from '../overflow-hover-tip';
import classNames from 'classnames';

import './PlainTable.scoped.less';

export type PlainTableProps = TableProps | {
  minHeight: number;
  maxHeight: number;
  width: number;
  wordWrap: boolean; // td 是否允许换行，默认为true；不换行时且文字溢出时，将使用Tip展示全部内容
  data: any[];
  columns: ColumnProps[];
  className?: string;
};

const PlainTable: React.FC<PlainTableProps> = (props) => {
  const {
    minHeight,
    maxHeight,
    width,
    data = [],
    columns = [],
    className,
    wordWrap = true,
    ...rest
  } = props;

  // 文字溢出时展示ToolTip
  const renderColumns = useMemo(() => {
    return _.map(columns, ({ render, maxWidth, ...columnProps }: ColumnProps) => {
      return {
        maxWidth,
        ...columnProps,
        // eslint-disable-next-line react/display-name
        render: (type: string, _name: string, value: any, data: any) => {
          const content = render?.(type, _name, value, data) || value;
          if (type !== 'data' || !maxWidth || !_.isString(content)) {
            return content;
          }
          return <OverflowHoverTip
            maxWidth={maxWidth}
            tip={content}>
            {
              typeof content === 'string'
                ? <span>{content}</span>
                : content
            }
          </OverflowHoverTip>;
        },
      };
    });
  }, [columns]);

  return <div
    className={classNames(
      'ptp-listview__main-area',
      'plain-table_cont',
      wordWrap ? 'word-wrap' : '',
      className,
    )}
  >
    <Table
      data={data}
      bordered={false}
      style={{
        minHeight: minHeight ? `${minHeight}px` : 'unset',
        maxHeight: maxHeight ? `${maxHeight}px` : 'unset',
        width: width ? `${width}px` : 'unset',
      }}
      className='table'
      {...rest}
    > {
        _.map(renderColumns, (column, index) => {
          const { title, ...otherColomnProps } = column;
          return <Column {...otherColomnProps}>
            {title}
          </Column>;
        })
      }
    </Table>
  </div>;
};

export default PlainTable;
